/* CLARITY Film — Abspiel-Knopf als Rueckfall. 28.08.2026

   Haengt sich an die bestehende Film-Sektion, ohne sie zu veraendern. Die
   Sektion setzt bei erfolgreichem Start die Klasse "is-playing" auf .cfi.
   Bleibt die nach einer Wartezeit aus UND steht das Video still, hat der
   Browser das automatische Abspielen abgelehnt — dann kommt der Knopf.

   Warum ueber eine Wartezeit und nicht ueber das play()-Versprechen: das
   Versprechen lebt in der Sektion selbst. Von aussen ist der beobachtbare
   Zustand (Klasse gesetzt / Video laeuft) der ehrlichere Messwert — er
   erfasst auch den Fall, dass die Quelle gar nicht erst geladen wurde.
*/
(function () {
  "use strict";

  var WARTEZEIT = 1400;   // ms — grosszuegig, damit langsame Netze nicht faelschlich als Fehler gelten

  function knopfBauen(root, vid) {
    var media = root.querySelector(".cfi-media") || root;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cfi-tap";
    btn.hidden = true;
    btn.setAttribute("aria-label", "Film abspielen");

    var icon = document.createElement("span");
    icon.className = "cfi-tap-icon";
    icon.setAttribute("aria-hidden", "true");

    var txt = document.createElement("span");
    txt.textContent = "Film abspielen";

    btn.appendChild(icon);
    btn.appendChild(txt);
    media.appendChild(btn);

    btn.addEventListener("click", function () {
      // Der Tipp selbst ist die Nutzergeste. Falls die Sektion die Quelle noch
      // nicht gesetzt hat (Datensparmodus, reduzierte Bewegung), hier nachholen.
      if (!vid.getAttribute("src")) {
        var mobil = window.matchMedia("(max-width: 760px)").matches;
        var src = root.getAttribute("data-src-m");
        if (!mobil) { src = root.getAttribute("data-src-d") || src; }
        if (src) { vid.src = src; }
      }
      var p = vid.play();
      if (p && p.then) {
        p.then(function () {
          root.classList.add("is-playing");
          knopfVerbergen(root, btn);
        })["catch"](function () { /* bleibt stehen, Knopf bleibt sichtbar */ });
      } else {
        root.classList.add("is-playing");
        knopfVerbergen(root, btn);
      }
    });

    return btn;
  }

  function knopfZeigen(root, btn) {
    btn.hidden = false;
    root.classList.add("needs-tap");
  }

  function knopfVerbergen(root, btn) {
    btn.hidden = true;
    root.classList.remove("needs-tap");
  }

  function pruefen(root) {
    var vid = root.querySelector(".cfi-video");
    if (!vid || root.__clTapInit) { return; }
    root.__clTapInit = true;

    var btn = knopfBauen(root, vid);

    function urteilen() {
      var laeuft = root.classList.contains("is-playing") ||
                   (!vid.paused && !vid.ended && vid.readyState > 2);
      if (laeuft) { knopfVerbergen(root, btn); } else { knopfZeigen(root, btn); }
    }

    // Erst pruefen, wenn die Sektion ihren Versuch hinter sich hat. Sie startet
    // ueber einen IntersectionObserver, also erst messen, wenn die Sektion im
    // Blickfeld war — sonst meldet der Knopf einen Fehler, den es nicht gibt.
    var gesehen = false;
    function nachSicht() {
      if (gesehen) { return; }
      gesehen = true;
      window.setTimeout(urteilen, WARTEZEIT);
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { nachSicht(); io.disconnect(); }
      }, { rootMargin: "200px" });
      io.observe(root);
    } else {
      nachSicht();
    }

    // Laeuft der Film spaeter doch an, verschwindet der Knopf von selbst.
    vid.addEventListener("playing", function () { knopfVerbergen(root, btn); });
  }

  function start() {
    var alle = document.querySelectorAll(".cfi");
    for (var i = 0; i < alle.length; i++) { pruefen(alle[i]); }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
